module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("hVd95"))).then(() => parcelRequire('jZ49y'));